import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimContractSubObjectUpdateInput } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimUpdateWorkOrderSubObjectGql } from '../../bimWorkOrderQueries';

const requestId = 'bimUpdateWorkOrderSubObject';

export const useBimUpdateWorkOrderSubObject = (workOrderId?: number, onSuccess?: () => void) => {
    const dispatch = useDispatch();

    const [bimUpdateWorkOrderSubObjectReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimUpdateWorkOrderSubObjectReset(undefined);
        onSuccess?.();
    }, [bimUpdateWorkOrderSubObjectReset, onSuccess]);

    const [
        bimUpdateWorkOrderSubObjectData,
        bimUpdateWorkOrderSubObjectStatus,
        bimUpdateWorkOrderSubObjectError,
        bimUpdateWorkOrderSubObjectRequest,
    ] = useRequest({
        requestId,
        query: bimUpdateWorkOrderSubObjectGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimUpdateWorkOrderSubObjectMakeRequest = useCallback(
        (input: BimContractSubObjectUpdateInput) => {
            dispatch(bimUpdateWorkOrderSubObjectRequest({ workOrderId, input }));
        },
        [bimUpdateWorkOrderSubObjectRequest, dispatch, workOrderId],
    );

    useEffect(() => {
        bimUpdateWorkOrderSubObjectReset(undefined);
    }, [bimUpdateWorkOrderSubObjectReset]);

    return {
        bimUpdateWorkOrderSubObjectData,
        bimUpdateWorkOrderSubObjectStatus,
        bimUpdateWorkOrderSubObjectError,
        bimUpdateWorkOrderSubObjectMakeRequest,
    };
};
